module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-layout mdl-js-layout mdl-layout--fixed-header"
  }, [_c('app-header'), _vm._v(" "), _c('app-drawer'), _vm._v(" "), _c('main', {
    staticClass: "mdl-layout__content"
  }, [_c('router-view')], 1), _vm._v(" "), _c('app-action-bar')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14d6fec9","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/Home/index.vue
// module id = 225
// module chunks = 0